// transcribeApi — typed client for the Transcribe service (/api/transcribe/*).
// Same shape as payrollApi: bearer token from localStorage, thin call<T> wrapper.
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
function token(): string | null { return localStorage.getItem('akt_auth_token'); }

async function call<T>(path: string, opts: RequestInit = {}): Promise<T> {
  const r = await fetch(`${API_BASE}/transcribe${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token()}`,
      ...(opts.headers || {}),
    },
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({} as any));
    const e: any = new Error(body.message || `Request failed (${r.status})`);
    e.code = r.status;
    throw e;
  }
  return r.json();
}

export interface TranscribeSetting {
  transcribe_setting_id: number;
  account_owner_id: number;
  engine: 'browser' | 'local';
  model_size: 'tiny' | 'base' | 'small' | 'medium' | 'large-v3';
  language: string;
  task: 'transcribe' | 'translate';
  autosave_to_notes: number;
  retention_days: number;
  local_engine_url: string | null;
}

export interface SavedTranscript {
  note_id: number;
  title: string;
  content_text: string;
  key_takeaway: string | null;
  tags: string | null;
  created_at: string;
  expires_at: string | null;
}

export interface SaveToNotesInput {
  title: string;
  transcript: string;
  sourceLink?: string;
  sourceName?: string;
  language?: string;
  model?: string;
  engine?: string;
  durationSec?: number;
  keyTakeaway?: string;
}

export const getSettings = () => call<TranscribeSetting>('/settings');
export const updateSettings = (s: Partial<TranscribeSetting>) =>
  call<TranscribeSetting>('/settings', { method: 'PUT', body: JSON.stringify(s) });

export const saveToNotes = (input: SaveToNotesInput) =>
  call<{ note_id: number; title: string; expires_at: string; created_at: string }>(
    '/save-to-notes', { method: 'POST', body: JSON.stringify(input) },
  );

export const listSaved = () => call<SavedTranscript[]>('/saved');
export const deleteSaved = (noteId: number) =>
  call<{ deleted: boolean }>(`/saved/${noteId}`, { method: 'DELETE' });
